import React, { FC } from 'react';
import { Control, Controller, UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import Button, { IButtonProps } from '@ui/atoms/Button';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import NavigationSection from '@ui/atoms/NavigationSection';

import TextArea from '@ui/forms/TextArea';

import fullWidth from '@ui/styled/FullWidth';

import { commonLabels } from '@utils/button';

import { ICancelationSurveyCommonProps } from '../types';

interface IAdditionalInfoViewProps extends Pick<ICancelationSurveyCommonProps, 'pageContent'> {
	control: Control<
		Partial<{
			[x: string]: unknown;
		}>,
		unknown
	>;
	getValues: UseFormGetValues<
		Partial<{
			[x: string]: unknown;
		}>
	>;
	setValue: UseFormSetValue<
		Partial<{
			[x: string]: unknown;
		}>
	>;
	setView: React.Dispatch<React.SetStateAction<'cancelation_survey' | 'additional_info'>>;
}

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);
const FullWidthButton = fullWidth<IButtonProps>(Button);

const AdditionalInfoView: FC<IAdditionalInfoViewProps> = ({
	control,
	getValues,
	pageContent,
	setValue,
	setView,
}) => {
	const { additionalInfoHeader, additionalInfoPlaceholder } = pageContent;

	return (
		<FullWidthColumn gap="xxl">
			<Controller
				name="feedback"
				control={control}
				render={(field) => (
					<TextArea
						{...field}
						label={additionalInfoHeader}
						labelVariant="heading"
						placeholder={additionalInfoPlaceholder}
						value={getValues('feedback')}
						onChange={(e) => setValue('feedback', e?.target?.value)}
					/>
				)}
			/>
			<NavigationSection>
				<FullWidthButton
					variant="default"
					label={commonLabels.back}
					type="button"
					onClick={() => setView('cancelation_survey')}
				/>
				<FullWidthButton variant="secondary" label={commonLabels.submit} type="submit" />
			</NavigationSection>
		</FullWidthColumn>
	);
};

export default AdditionalInfoView;
